
var globalMsg = (function () {
    "use strict";

    var timeout;

    /**
     * Get from HTML or append new element
     * @return {jQuery}
     * @author Andraz <andraz@easistent.com>
     */
    var getGlobalMsg = function () {
        var $el = $('#global-msg');

        if ($el.length === 0) {
            $el = $('<div>', {
                id: 'global-msg'
            }).appendTo('body');
        }

        return $el;
    };

    /**
     * Hide global msg cloud
     * @return {void}
     * @author Andraz <andraz@easistent.com>
     */
    var hide = function () {
        var $msg = getGlobalMsg();
        $msg.addClass('hidden');
    }

    var center = function ($msg) {
        //$msg.css('margin-left', -1 * Math.round($msg.width() / 2));
    };

    //////////
    // INIT //
    //////////
    center(getGlobalMsg());

    return {
        /**
         * Fill HTML and position msg
         * @param  {string} html
         * @return {void}
         * @author Andraz <andraz@easistent.com>
         */
        show: function (html) {
            var $msg = getGlobalMsg();
            var screen_width = $(window).width();
            var width = screen_width > 500 ? 500 : screen_width;

            $msg.removeClass('hidden');

            $msg.html(html);
            $msg.width(width);

            if (screen_width > 500) {
                $msg.offset({
                    //top: 48,
                    left: (screen_width / 2) - 250
                });
            }

            center($msg);
        },

        hide: hide,

        hideOnTimeout: function (delay) {

            delay = delay || 3000;

            timeout = setTimeout(hide, delay);
        }
    };
}());
